import React from 'react';
import styles from './modal.module.scss';
import SimpleBar from 'simplebar-react';

type Props = {
  children: JSX.Element | JSX.Element[];
};

const ModalBody = (props: Props) => {
  const { children } = props;

  return (
    <div className={styles.modalBody}>
      <SimpleBar className={styles.scrollbar}>{children}</SimpleBar>
    </div>
  );
};

export default ModalBody;

ModalBody.displayName = 'Modal.Body';
